import { Grid } from '@mui/material';
import useStore from '../zustand/useStore';
import StatementCard from './StatementCard';

const CardView = () => {
  const { cards } = useStore((state) => ({ cards: state.MUIdata.rows }));
  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={12}>
        <div className="card-view">
          {cards.map((card, i) => {
            return <StatementCard key={i} data={card} />;
          })}
        </div>
      </Grid>
    </Grid>
  );
};

export default CardView;
